import { Button, Grid, MenuItem, Popover } from '@mui/material';
import { format } from 'date-fns';
import { useState } from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import TextField from 'common/forms/TextField';
import SelectField from 'common/forms/SelectField';
import DateRangePickerField from 'common/forms/DateRangePickerField';
import { filterReceivings } from 'store/thunks/stockManagementThunk';

const STATUSES = ['PENDING_VERIFICATION', 'VERIFIED', 'ADJUSTED'];

const StockManagementFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const [receivedDateRange, setReceivedDateRange] = useState(null);

  const filter = useSelector(({ inventory }) => inventory.stockManagement.filter);

  const popoverId = anchorEl ? 'stock-management-filter-popover' : undefined;

  const handleOpen = (event) => {
    const existingDateRange =
      filter?.receivedDateFrom || filter?.receivedDateTo
        ? [filter.receivedDateFrom, filter.receivedDateTo].filter(Boolean)
        : null;
    setReceivedDateRange(existingDateRange);
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);
    dispatch(
      filterReceivings({
        filter: {
          ...formData,
          receivedDateFrom: receivedDateRange?.[0] || undefined,
          receivedDateTo:
            receivedDateRange?.[1] ||
            (receivedDateRange?.[0] ? format(new Date(), 'yyyy-MM-dd') : undefined),
        },
      })
    );
  };

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <Grid
          container
          sx={{ p: 1.5, width: 325, maxHeight: '80vh', overflowY: 'auto' }}
          spacing={2}
          direction='column'
        >
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <DateRangePickerField
                      label='Received Date'
                      initialValue={receivedDateRange}
                      onDateChange={(dateRange) => setReceivedDateRange(dateRange)}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField label='Vendor Name' name='vendorName' id='stock-filter-vendorName' />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Manifest Reference'
                      name='manifestReference'
                      id='stock-filter-manifestReference'
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField label='Status' name='status' id='stock-filter-status'>
                      <MenuItem value=''>All</MenuItem>
                      {STATUSES.map((s) => (
                        <MenuItem key={s} value={s}>
                          {s.replace(/_/g, ' ')}
                        </MenuItem>
                      ))}
                    </SelectField>
                  </Grid>
                  <Grid container justifyContent='flex-end' sx={{ mt: 1 }}>
                    <Button variant='contained' type='submit' disabled={invalid}>
                      Apply
                    </Button>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default StockManagementFilterButton;
